import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './PokemonBuilder.css';

const ScarletVioletGuide = ({ itemSprites }) => (
  <div className="builder-grid">
    <div className="guide-card vitamins">
      <div className="card-header">
        <img src={itemSprites['HP Up']} alt="HP Up" className="item-sprite" />
        <h3>Vitamins &amp; EV Training</h3>
      </div>
      <div className="vitamin-grid">
        <div className="vitamin-item">
          <img src={itemSprites['HP Up']} alt="HP Up" />
          <span>HP Up</span>
          <small>HP EVs</small>
        </div>
        <div className="vitamin-item">
          <img src={itemSprites['Protein']} alt="Protein" />
          <span>Protein</span>
          <small>Attack EVs</small>
        </div>
        <div className="vitamin-item">
          <img src={itemSprites['Iron']} alt="Iron" />
          <span>Iron</span>
          <small>Defense EVs</small>
        </div>
        <div className="vitamin-item">
          <img src={itemSprites['Calcium']} alt="Calcium" />
          <span>Calcium</span>
          <small>Sp. Atk EVs</small>
        </div>
        <div className="vitamin-item">
          <img src={itemSprites['Zinc']} alt="Zinc" />
          <span>Zinc</span>
          <small>Sp. Def EVs</small>
        </div>
        <div className="vitamin-item">
          <img src={itemSprites['Carbos']} alt="Carbos" />
          <span>Carbos</span>
          <small>Speed EVs</small>
        </div>
      </div>
      <div className="card-info">
        <p><strong>Location:</strong> Any Delibird Presents shop in major cities</p>
        <p><strong>Cost:</strong> 10,000₽ each</p>
        <p><strong>Limit:</strong> Up to 26 of each vitamin per Pokémon</p>
      </div>
    </div>

    <div className="guide-card tera">
      <div className="card-header">
        <img src={itemSprites['Normal Tera Shard']} alt="Tera Shard" className="item-sprite" />
        <h3>Tera Type Change</h3>
      </div>
      <div className="tera-content">
        <div className="step-list">
          <div className="step">
            <span className="step-number">1</span>
            <p>Complete the main story to unlock Tera Raids</p>
          </div>
          <div className="step">
            <span className="step-number">2</span>
            <p>Collect Tera Shards from Tera Raids</p>
          </div>
          <div className="step">
            <span className="step-number">3</span>
            <p>Visit Treasure Eatery in Medali</p>
          </div>
          <div className="step">
            <span className="step-number">4</span>
            <p>Spend 50 Tera Shards to change type</p>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card natures">
      <div className="card-header">
        <img src={itemSprites['Adamant Mint']} alt="Nature Mint" className="item-sprite" />
        <h3>Nature Change</h3>
      </div>
      <div className="nature-content">
        <div className="mint-info">
          <img src={itemSprites['Adamant Mint']} alt="Nature Mint" className="mint-image" />
          <div>
            <p><strong>Location:</strong> Cascarrafa, Levincia, Mesagoza, Montenevera</p>
            <p><strong>Cost:</strong> 20,000₽ each</p>
            <p><strong>Effect:</strong> Changes stat calculation without changing original nature</p>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card moves">
      <div className="card-header">
        <img src={itemSprites['TM001']} alt="TM" className="item-sprite" />
        <h3>TM Learning</h3>
      </div>
      <div className="tm-content">
        <div className="tm-steps">
          <div className="tm-step">
            <img src={itemSprites['TM001']} alt="TM Machine" />
            <div>
              <h4>TM Machine</h4>
              <p>Visit any Pokémon Center to access the TM Machine</p>
            </div>
          </div>
          <div className="tm-step">
            <img src={itemSprites['TM001']} alt="TM" />
            <div>
              <h4>Materials &amp; LP</h4>
              <p>Collect materials from wild Pokémon and use LP to craft TMs</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card mirror-herb">
      <div className="card-header">
        <img src={itemSprites['Mirror Herb']} alt="Mirror Herb" className="item-sprite" />
        <h3>Move Inheritance</h3>
      </div>
      <div className="mirror-content">
        <div className="mirror-info">
          <img src={itemSprites['Mirror Herb']} alt="Mirror Herb" className="mirror-image" />
          <div className="mirror-steps">
            <p><strong>Location:</strong> Casseroya Lake area</p>
            <p><strong>Effect:</strong> Allows Pokémon to learn moves from others in your party</p>
            <div className="strategy-steps">
              <div className="strategy-step">
                <span className="step-number">1</span>
                <p>Find a Pokémon with the move</p>
              </div>
              <div className="strategy-step">
                <span className="step-number">2</span>
                <p>Give Mirror Herb to recipient</p>
              </div>
              <div className="strategy-step">
                <span className="step-number">3</span>
                <p>Ensure an empty move slot</p>
              </div>
              <div className="strategy-step">
                <span className="step-number">4</span>
                <p>Have a picnic together</p>
              </div>
              <div className="strategy-step">
                <span className="step-number">5</span>
                <p>Verify move was learned</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card stats">
      <div className="card-header">
        <img src={itemSprites['Bottle Cap']} alt="Bottle Cap" className="item-sprite" />
        <h3>IV &amp; EV Optimization</h3>
      </div>
      <div className="stats-content">
        <div className="bottle-caps">
          <h4>Hyper Training</h4>
          <div className="cap-types">
            <div className="cap-item">
              <img src={itemSprites['Bottle Cap']} alt="Bottle Cap" className="cap-image" />
              <div>
                <p><strong>Regular Bottle Cap</strong></p>
                <p>Maximizes one IV stat</p>
              </div>
            </div>
            <div className="cap-item">
              <img src={itemSprites['Gold Bottle Cap']} alt="Gold Bottle Cap" className="cap-image" />
              <div>
                <p><strong>Gold Bottle Cap</strong></p>
                <p>Maximizes all IV stats</p>
              </div>
            </div>
          </div>
          <div className="requirements">
            <p><strong>Requirements:</strong></p>
            <ul>
              <li>Pokémon must be level 50</li>
              <li>Visit the Hyper Training NPC in Naranja/Uva Academy's Staff Break Room</li>
              <li>Regular Bottle Caps can be obtained from:
                <ul>
                  <li>Delibird Presents (20,000₽ each)</li>
                  <li>5+★ Tera Raid rewards</li>
                  <li>Item Printer</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card material-exchange">
      <div className="card-header">
        <img src={itemSprites['TM001']} alt="Item Printer" className="item-sprite" />
        <h3>Item Printer</h3>
      </div>
      <div className="exchange-content">
        <div className="exchange-info">
          <div>
            <p><strong>Location:</strong> BP League Room at Blueberry Academy</p>
            <p><strong>Cost:</strong> BP + Pokémon Materials</p>
            <p><strong>Potential Rewards:</strong></p>
            <ul>
              <li>Ability Capsules</li>
              <li>Bottle Caps</li>
              <li>Nature Mints</li>
              <li>Rare Candies</li>
              <li>TMs</li>
              <li>And more!</li>
            </ul>
            <p><strong>Tip:</strong> A great way to convert excess Pokémon materials and BP into valuable competitive items</p>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card abilities">
      <div className="card-header">
        <img src={itemSprites['Ability Capsule']} alt="Ability Items" className="item-sprite" />
        <h3>Ability Changes</h3>
      </div>
      <div className="ability-content">
        <div className="ability-info">
          <div>
            <div className="ability-types">
              <h4>Understanding Abilities</h4>
              <ul>
                <li><strong>Standard Abilities:</strong> Most Pokémon have two possible standard abilities</li>
                <li><strong>Hidden Ability:</strong> A special third ability some Pokémon can have</li>
              </ul>
            </div>
            <div className="ability-items">
              <div className="ability-item">
                <h4>Ability Capsule</h4>
                <img src={itemSprites['Ability Capsule']} alt="Ability Capsule" className="item-sprite" />
                <ul>
                  <li>Switches between standard abilities only</li>
                  <li>Cannot access hidden ability</li>
                </ul>
              </div>
              <div className="ability-item">
                <h4>Ability Patch</h4>
                <img src={itemSprites['Ability Patch']} alt="Ability Patch" className="item-sprite" />
                <ul>
                  <li>Changes to hidden ability</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ChampionsGuide = () => (
  <div className="builder-grid">

    <div className="guide-card">
      <div className="card-header">
        <h3>Victory Points (VP) Overview</h3>
      </div>
      <div className="champ-info-block">
        <p>
          VP is the currency used for all Pokémon customisation in Champions.
          It is <strong>earned through gameplay only</strong> — it cannot be purchased with real money.
        </p>
        <div className="champ-stat-grid">
          <div className="champ-stat-row">
            <span className="champ-stat-label">Ranked Win</span>
            <span className="champ-stat-val">200+ VP</span>
          </div>
          <div className="champ-stat-row">
            <span className="champ-stat-label">Ranked Loss</span>
            <span className="champ-stat-val">Some VP</span>
          </div>
          <div className="champ-stat-row">
            <span className="champ-stat-label">Battle Pass rewards</span>
            <span className="champ-stat-val">Varies</span>
          </div>
          <div className="champ-stat-row">
            <span className="champ-stat-label">Other in-game activities</span>
            <span className="champ-stat-val">Varies</span>
          </div>
        </div>
        <div className="champ-note">
          <strong>Key tip:</strong> Importing Pokémon from HOME that already have the right moves, ability, and nature can reduce a full team build from ~33,000 VP down to ~6,000 VP.
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Recruiting Pokémon</h3>
      </div>
      <div className="champ-info-block">
        <p>Pokémon are recruited from <strong>Roster Ranch</strong> using VP or Teammate Tickets.</p>
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Method</span>
            <span>Cost</span>
          </div>
          <div className="champ-cost-row">
            <span>Recruit with VP</span>
            <span className="champ-cost-val">~2,500 VP each</span>
          </div>
          <div className="champ-cost-row">
            <span>Teammate Ticket</span>
            <span className="champ-cost-free">Free (0 VP)</span>
          </div>
          <div className="champ-cost-row">
            <span>HOME transfer (eligible Pokémon)</span>
            <span className="champ-cost-free">Free (0 VP)</span>
          </div>
        </div>
        <div className="champ-note">
          Use <strong>Trial Recruitment</strong> to test a Pokémon before committing VP. Training is disabled during trials.
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Stat Points (EV Equivalent)</h3>
      </div>
      <div className="champ-info-block">
        <p>
          Stat Points replace EVs. Instead of grinding battles, you spend VP directly to allocate them.
        </p>
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Action</span>
            <span>Cost</span>
          </div>
          <div className="champ-cost-row">
            <span>1 Stat Point</span>
            <span className="champ-cost-val">5 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Max one stat (32 points)</span>
            <span className="champ-cost-val">160 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Training Ticket</span>
            <span className="champ-cost-free">Replaces VP entirely</span>
          </div>
        </div>
        <div className="champ-note">
          Training Tickets zero out the VP cost. The Champions+ Starter Pack includes 50 of them.
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Changing Moves</h3>
      </div>
      <div className="champ-info-block">
        <p>
          Moves are changed directly in the training menu by spending VP — no TM machines or move tutors required.
        </p>
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Action</span>
            <span>Cost</span>
          </div>
          <div className="champ-cost-row">
            <span>Change a move</span>
            <span className="champ-cost-val">250 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>With Training Ticket</span>
            <span className="champ-cost-free">0 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>HOME import (existing moves)</span>
            <span className="champ-cost-free">No cost if moves carry over</span>
          </div>
        </div>
        <div className="champ-note">
          Moves that don't exist in Champions will need replacing after a HOME transfer. Plan your import movesets before transferring.
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Nature / Stat Alignment</h3>
      </div>
      <div className="champ-info-block">
        <p>
          Natures are called <strong>Stat Alignment</strong> in Champions but work identically —
          one stat boosted 10%, one reduced 10%.
        </p>
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Action</span>
            <span>Cost</span>
          </div>
          <div className="champ-cost-row">
            <span>Change Stat Alignment</span>
            <span className="champ-cost-val">500 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>With Training Ticket</span>
            <span className="champ-cost-free">0 VP</span>
          </div>
        </div>
        <div className="champ-note">
          At 500 VP per change, natures add up fast across a team of 6. Import Pokémon from HOME with the correct nature already set to skip this cost.
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Ability Changes</h3>
      </div>
      <div className="champ-info-block">
        <p>
          Standard abilities are free to swap. Hidden Abilities cost VP — equivalent to an Ability Patch in S/V.
        </p>
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Ability Type</span>
            <span>Cost</span>
          </div>
          <div className="champ-cost-row">
            <span>Switch between standard abilities</span>
            <span className="champ-cost-free">0 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Unlock Hidden Ability</span>
            <span className="champ-cost-val">500 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>With Training Ticket</span>
            <span className="champ-cost-free">0 VP</span>
          </div>
        </div>
      </div>
    </div>

    <div className="guide-card">
      <div className="card-header">
        <h3>Full Team Cost Estimates</h3>
      </div>
      <div className="champ-info-block">
        <div className="champ-cost-table">
          <div className="champ-cost-row champ-cost-row--header">
            <span>Scenario</span>
            <span>Approx. VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Fully build 1 Pokémon (recruit + train)</span>
            <span className="champ-cost-val">~4,300 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Full team of 6 from scratch</span>
            <span className="champ-cost-val">~25,000 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Full team via HOME transfers, pre-built</span>
            <span className="champ-cost-free">~2,000 VP</span>
          </div>
          <div className="champ-cost-row">
            <span>Retrain existing Pokémon (stats only)</span>
            <span className="champ-cost-free">~320 VP each</span>
          </div>
        </div>
        <div className="champ-note champ-note--highlight">
          <strong>Best strategy for new players:</strong> Start with rental teams (0 VP), earn VP through Ranked and Casual battles, then use Teammate Tickets and HOME transfers to build your first team cheaply.
        </div>
      </div>
    </div>

  </div>
);

const PokemonBuilder = () => {
  const [activeTab, setActiveTab] = useState('champions');
  const [itemSprites, setItemSprites] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const items = [
          'HP Up', 'Protein', 'Iron', 'Calcium', 'Zinc', 'Carbos',
          'Adamant Mint', 'Normal Tera Shard', 'TM001', 'Mirror Herb',
          'Bottle Cap', 'Gold Bottle Cap', 'Ability Capsule', 'Ability Patch',
        ];
        const responses = await Promise.all(
          items.map(item =>
            fetch(`${API_URL}/items/${encodeURIComponent(item)}`).then(res => res.json())
          )
        );
        const sprites = {};
        responses.forEach((response, index) => {
          if (response && response.sprite) {
            sprites[items[index]] = response.sprite;
          }
        });
        setItemSprites(sprites);
      } catch (error) {
        console.error('Error fetching items:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, []);

  if (loading) {
    return <div className="loading">Loading items...</div>;
  }

  return (
    <div className="pokemon-builder">
      <div className="builder-header">
        <h2>Building Your Perfect Pokémon</h2>
        <p>A guide to competitive Pokémon preparation — choose your platform below</p>
      </div>

      <div className="builder-tabs">
        <button
          className={`builder-tab${activeTab === 'champions' ? ' builder-tab--active' : ''}`}
          onClick={() => setActiveTab('champions')}
        >
          Pokémon Champions
          <span className="builder-tab-badge builder-tab-badge--new">Current</span>
        </button>
        <button
          className={`builder-tab${activeTab === 'sv' ? ' builder-tab--active' : ''}`}
          onClick={() => setActiveTab('sv')}
        >
          Scarlet &amp; Violet
          <span className="builder-tab-badge builder-tab-badge--legacy">Legacy</span>
        </button>
      </div>

      {activeTab === 'champions'
        ? <ChampionsGuide />
        : <ScarletVioletGuide itemSprites={itemSprites} />
      }
    </div>
  );
};

export default PokemonBuilder;
